
import router from '@/router'
import { defineComponent, ref} from 'vue'
import { RecommendService } from '@/api/recommand'
import LayoutHeader from '../components/layout/Header.vue'
import LayoutFooter from '../components/layout/Footer.vue'
import { MemberService } from '@/api/member'
import { message } from 'ant-design-vue'
export default defineComponent({
  name: 'Subject',
  components: {
    LayoutHeader, LayoutFooter
  },
  setup() {
    const subjectId = ref(String(router.currentRoute.value.params.subjectId))
    const template = ref({})
    const getTemplate = async () => {
      const res = await RecommendService.getSubjectDetail(subjectId.value)
      if (res.data.data ) {
        const _data = res.data.data
        _data.subjectList.forEach((d: any) => {
          d.showList = d.pptTemplateList.slice(0,12)
          d.showInd = 1
          d.showLength = Math.ceil(d.pptTemplateList.length / 12)
        })
        template.value = _data
      }
    }
    const onNext = (res:any) => {
      if (res.showInd === res.showLength) return
      res.showInd ++
      res.showList = res.pptTemplateList.slice((res.showInd - 1) * 12, res.showInd * 12)
    }
    const onPre = (res:any) => {
       
      if (res.showInd <= 1) return

      res.showInd --
      res.showList = res.pptTemplateList.slice((res.showInd - 1) * 12, ((res.showInd) * 12))
    }
    const onCollect = async (id: any) => {
      const params = {
        contentId:id
      }
      const res = await MemberService.addCollect(params)
      if (res.data.state === 2) {
        message.success('收藏成功')
      }
      else {
        message.error(res.data.msg)
      }
      
    }
    getTemplate()
    return {
      template,
      onNext,
      onPre,
      onCollect
    }
  },
})
